import axiosInstance from '../axiosConfigCMS';

export default {
  async getContent() {
    const response = await axiosInstance.get('/delivery-description');
    return response.data;
  },
};
